/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_No_Ready_ImagesInputs */

const cs_property_ai_no_ready_images = /** @type {(inputs: Property_Ai_No_Ready_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné hotové fotky.`)
};

const en_property_ai_no_ready_images = /** @type {(inputs: Property_Ai_No_Ready_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ready images.`)
};

/**
* | output |
* | --- |
* | "No ready images." |
*
* @param {Property_Ai_No_Ready_ImagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_no_ready_images = /** @type {((inputs?: Property_Ai_No_Ready_ImagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_No_Ready_ImagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_no_ready_images(inputs)
	return cs_property_ai_no_ready_images(inputs)
});